import React from "react";


  export const NextButton = ({paginate}) => {


    return ( 
                   <>
                   
                        <div className="nextBtnWrapper">                            
                            <div id="nextBtnWrapper" className="next relative mx-4 " onClick={() => paginate(1)}>
                                    {"next"}
                            </div>
                        </div>
                     </>
    )
}




export const PrevButton = ( {paginate}) => {


    return ( 
                   <>
                        <div className="prevBtnWrapper">                            
                               <div id="prevBtnWrapper" className="prev relative  mx-4" onClick={() => paginate(-1)}>
                                   {"prev"}
                                </div>
                        </div>
                    </>
    )
}